<template>
  <frontPage/>
  <div>
      <h2>User Profile</h2>

      <pre v-if="isAuthenticated">
        <code>{{ user }}</code>

      </pre>

     <button1 @click="sendUserData"></button1>
    <button1 @click="generateApiKey">Generate API Key</button1>
    <p v-if="apiKey">Generated API Key: {{ apiKey }}</p>
  </div>
</template>
<script>
import frontPage from './frontPage.vue';
import { useAuth0 } from '@auth0/auth0-vue';
import axios from 'axios';
import { ref } from 'vue';
import { watch } from 'vue';


export default {
  components: {
    frontPage
  },
  setup() {
    const { loginWithRedirect, user, isAuthenticated, idTokenClaims } = useAuth0();
    const apiKey = ref('');

    const generateApiKey = async () => {
      try {
        const response = await axios.post(
          'http://18.222.150.95/graphql',
          {
            query: `
              mutation GenerateApiKey($user: String!) {
                generateApiKey(user: $user)
              }
            `,
            variables: { user: JSON.stringify(idTokenClaims) }, // Pass the idTokenClaims as a JSON string
          },
          {
            headers: {
              Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ik1pdGNoIiwidXNlcm5hbWUiOiJtaXRjaGVsbF93byIsInJvbGVzIjpbImFkbWluIl0sImlhdCI6MTY5MzQyMTk2MH0.75IQ1_HEkGdpGboxb8nMLFZdahVBxag-OmfXnIkwgZ8', // Send the ID token from Auth0 as the Bearer token
            },
          }
        );

        apiKey.value = response.data.data.generateApiKey;

        
      }

      
      
      catch (error) {
        console.error('Error generating API Key:', error);
      }
    };

    const sendUserData = async () => {
      
        const userPayload = {
          id: user,
          
          // Add other user data as needed
        };

        try {
          await axios.post('http://localhost:62089/api/user', userPayload);
        } catch (error) {
          console.error('Error sending user data:', error);
        }
        console.log(userPayload)
      
    };

    // Watch for changes in isAuthenticated and call sendUserData when it becomes true
    watch(isAuthenticated, (value) => {
      if (value) {
        sendUserData();
      }
    });



    return {
      login: () => {
        loginWithRedirect();
      },
      user,
      isAuthenticated,
      generateApiKey,
      apiKey,
      idTokenClaims,
      sendUserData,
    };
  },
};
</script>
